import qs from 'qs';

export default hash => qs.parse(hash.substring(hash.indexOf('?') + 1)).useHash === 'true';
